module.exports = {
  src: __webpack_public_path__ + "assets/images/check-icon-green.970b721f94b9d271.svg",
  width: 17,
  height: 15,
  toString: function() { return __webpack_public_path__ + "assets/images/check-icon-green.970b721f94b9d271.svg"; }
};